// MOCK DATA for Alameda Brazilian Jiu-Jitsu Academy
// Pricing verified by the owner. Wix (alamedabjj.com) is the only checkout platform.

export const CONTACT = {
  email: "info@alamedabjj.com",
  phone: "341-688-6866",
  phoneHref: "tel:3416886866",
  address: "2227 Mariner Square Loop, Alameda, California 94501",
  addressShort: "2227 Mariner Square Loop, Alameda, CA 94501",
  addressNote: "Inside Alameda Fitness & Spa",
  mapQuery: "2227 Mariner Square Loop, Alameda, CA 94501",
};

// Areas served (SEO)
export const FAQS = [
  { q: "Do I need any experience to start?", a: "None at all. The large majority of our students begin with zero experience. Every class is structured so complete beginners can follow along safely and comfortably." },
  { q: "Is Brazilian Jiu-Jitsu safe for kids?", a: "Yes. Our kids classes are taught in a safe, respectful, supervised environment with age-appropriate techniques. Children progress gradually while building confidence, discipline and anti-bullying skills." },
  { q: "Am I too old or out of shape to train?", a: "Not at all. Students of many ages and fitness levels train with us — including complete beginners over 30 and 40. Your fitness improves naturally over time, and you go at your own pace." },
  { q: "What should we wear to the first class?", a: "Just bring comfortable athletic clothing (shorts/leggings and a t-shirt) for your free trial. If you enroll, we'll help you get a proper Gi (uniform)." },
  { q: "Can parents watch class?", a: "Absolutely. Parents are welcome to watch. Many families love seeing their child's progress and confidence grow week to week." },
  { q: "Where are you located and is it near Oakland or San Leandro?", a: "We're at 2227 Mariner Square Loop, Alameda, CA 94501 (inside Alameda Fitness & Spa) — an easy drive from Oakland, San Leandro, Bay Farm Island and the surrounding East Bay." },
  { q: "How do I book a free class?", a: "Just tap “Book a Free Class,” pick a day and program, and we'll confirm your spot. There's no commitment and your first class is free." },
];

export const AREAS = ["Alameda", "Oakland", "San Leandro", "Berkeley", "Emeryville", "Hayward", "East Bay"];
export const DISCIPLINES = [
  "Brazilian Jiu-Jitsu",
  "Submission Wrestling",
  "Mixed Martial Arts",
  "Kids Martial Arts",
  "Martial Arts for Adults",
  "Teens Martial Arts",
  "Self-Defense",
];


// Real Team Silva / Alameda BJJ photos
export const IMAGES = {
  logo: "/images/logo.png",
  hero: "/images/sergio-silva.jpg",
  competition: "/images/sergio-silva.jpg",
  instructor: "/images/sergio-silva.jpg",
  toddlers: "/images/toddlers.jpg",
  kids: "/images/kids-lineup.webp",
  teens: "/images/kids-teaching.jpg",
  teaching: "/images/kids-teaching.jpg",
  dojo: "/images/kids-lineup.webp",
  kidsBright: "/images/toddlers.jpg",
};

export const PROGRAMS = [
  {
    id: "toddlers",
    title: "Toddlers",
    ages: "Ages 2.5 – 5",
    image: IMAGES.toddlers,
    short: "Playful, movement-based classes that build coordination, focus and confidence.",
    points: [
      "Fun, game-based introduction to grappling",
      "Balance, coordination & motor skills",
      "Listening, focus and following directions",
    ],
  },
  {
    id: "kids",
    title: "Kids",
    ages: "Ages 5 – 11",
    image: IMAGES.kids,
    short: "Practical self-defense and anti-bullying skills that grow real confidence.",
    points: [
      "Anti-bullying & practical self-defense",
      "Discipline, respect and teamwork",
      "Fitness that keeps kids active and healthy",
    ],
  },
  {
    id: "teens",
    title: "Teens",
    ages: "Teenagers",
    image: IMAGES.teens,
    short: "Build strength, discipline and calm under pressure during the toughest years.",
    points: [
      "Confidence and stress management",
      "Real self-defense against bigger opponents",
      "A positive, focused peer community",
    ],
  },
  {
    id: "adults",
    title: "Adults",
    ages: "All levels welcome",
    image: IMAGES.competition,
    short: "Get in the best shape of your life while learning the world's most effective martial art.",
    points: [
      "Burn calories & build full-body strength",
      "Authentic Gi & No-Gi Jiu-Jitsu",
      "Beginner-friendly, no experience needed",
    ],
  },
  {
    id: "self-defense",
    title: "Self-Defense",
    ages: "Teens & Adults",
    image: IMAGES.teaching,
    short: "A proven self-defense system that works when it matters most.",
    points: [
      "Stay calm and think clearly under pressure",
      "Escape and control real-world situations",
      "Practical techniques for every body type",
    ],
  },
  {
    id: "verbal-jiu-jitsu",
    title: "Verbal Jiu-Jitsu\u2122",
    ages: "All ages",
    image: IMAGES.toddlers,
    short: "A unique communication system to recognize conflict early and defuse tension.",
    points: [
      "Recognize and de-escalate conflict early",
      "Protect your peace, body and future",
      "Confidence in words, not just on the mats",
    ],
  },
];

export const SCHEDULE = [
  {
    program: "Toddlers",
    ages: "2.5 – 5 years old",
    booking: "toddler-motor-fitness-brazilian-jiu-jitsu",
    sessions: [
      { day: "Monday", time: "4:15 PM" },
      { day: "Wednesday", time: "6:15 PM" },
    ],
  },
  {
    program: "Little Warriors",
    ages: "4 – 9 years old",
    booking: "kids-brazilian-jiu-jitsu-self-defense",
    sessions: [
      { day: "Monday", time: "6:00 PM" },
    ],
  },
  {
    program: "Kids",
    ages: "5 – 12 years old",
    booking: "kids-brazilian-jiu-jitsu-self-defense",
    sessions: [
      { day: "Monday – Thursday", time: "5:00 – 6:00 PM", popular: true },
      { day: "Tuesday & Thursday", time: "6:00 – 7:00 PM (kids, teens & adults)" },
      { day: "Saturday", time: "10:30 AM", popular: true },
    ],
  },
  {
    program: "Teens",
    ages: "Teenagers",
    booking: "teens-brazilian-jiu-jitsu-self-defense",
    sessions: [
      { day: "Tuesday & Thursday", time: "6:00 – 7:00 PM (kids, teens & adults)" },
    ],
  },
  {
    program: "Adults",
    ages: "All levels",
    booking: "adult-brazilian-jiu-jitsu-self-defense",
    sessions: [
      { day: "Monday & Wednesday", time: "6:00 AM" },
      { day: "Monday – Thursday", time: "7:00 PM", popular: true },
      { day: "Tuesday & Thursday", time: "6:00 – 7:00 PM (kids, teens & adults)" },
      { day: "Saturday", time: "9:30 AM" },
    ],
  },
  {
    program: "Private Lessons",
    ages: "All ages & levels",
    booking: "private-lesson-1",
    sessions: [
      { day: "By appointment", time: "Single $165 · 4-pack $500" },
    ],
  },
];

// Wix links (payments & booking continue to process on Wix)
export const WIX = {
  plans: "https://www.alamedabjj.com/plans-pricing",
  booking: "https://www.alamedabjj.com/book-online",
  bookingBase: "https://www.alamedabjj.com/booking-calendar/",
};

// FREE first class — primary CTA
export const FREE_CLASS = {
  name: "Free First Class",
  price: "$0",
  points: ["First class always FREE", "New students of all ages & experience levels", "No commitment, no purchase required"],
};

// $99 One-Month Tryout — featured offer (manual payment, pending until confirmed by owner)
export const TRYOUT = {
  name: "One-Month Brazilian Jiu-Jitsu Tryout",
  price: "$99",
  points: ["One month of BJJ & self-defense training", "Two classes per week", "FREE uniform included", "New students only", "No experience required", "One-time payment — no automatic renewal"],
  programs: ["Kids", "Teens", "Adults"],
  payments: [
    { id: "venmo", name: "Venmo", handle: "@alamedabjj", url: "https://venmo.com/u/alamedabjj", note: "Send $99 to @alamedabjj" },
    { id: "paypal", name: "PayPal", handle: "sergiobjj@hotmail.com", url: "", note: "Send $99 to sergiobjj@hotmail.com (Friends & Family or Goods & Services)" },
    { id: "zelle", name: "Zelle", handle: "341-688-6866", url: "", note: "Send $99 via your bank's Zelle to 341-688-6866" },
  ],
};

// $199 Kids Confidence & Discipline Challenge — official Wix checkout link pending
export const CHALLENGE = {
  name: "Kids Confidence & Discipline Challenge",
  tagline: "6 Weeks to Build Confidence, Discipline & Real-Life Skills!",
  by: "By Professor Sérgio Silva | Alameda Kids Martial Arts",
  price: "$199",
  summary: "Six weeks of unlimited eligible martial arts training for children — FREE uniform included. New students only.",
  includes: ["Brazilian Jiu-Jitsu", "Verbal Jiu-Jitsu™", "Practical self-defense", "Life skills", "Confidence development", "Discipline & focus", "Physical fitness", "Respect & resilience"],
  url: "https://www.alamedabjj.com/checkout?checkoutId=51fcf838-1ed2-4b15-914c8ea21c&disableContinueShopping=true",
};

// Month-to-month memberships (prices from Wix). Buttons link to the Wix plans page.
export const PRICING = [
  { id: "1x", name: "1 Class / Week", price: "$155", period: "/ month", features: ["Train once a week", "Perfect entry point for beginners", "Month-to-month, no long-term contract"], highlight: false },
  { id: "2x", name: "2 Classes / Week", price: "$189", period: "/ month", features: ["Train twice a week", "Strong fundamentals & steady progress", "Month-to-month, no long-term contract"], highlight: false },
  { id: "unlimited", name: "Unlimited Training", price: "$225", period: "/ month", features: ["Unlimited classes & training", "Gi, No-Gi, Self-Defense & more", "Month-to-month, no long-term contract"], highlight: true },
];

// Commitment memberships. URLs are the owner's exact Wix checkout links ("" = awaiting official link).
export const COMMITMENT_PLANS = [
  { id: "kids-6mo", name: "Toddlers & Kids Unlimited", price: "$139", period: "/ month", term: "6-month commitment", features: ["Unlimited toddler & kids classes", "Confidence, discipline & anti-bullying skills", "Lowest monthly rate for kids"], url: "https://www.alamedabjj.com/pricing-plans/plan-customization?planId=716b805e-d0df-413d-9e26-fa9078fe29d4&checkoutFlowId=a3b87492-5b88-4a68-9a4b-a35063f7cc66&pricingVariantId=3175683f-a63a-469f-aa85-cf52b07ca10c" },
  { id: "adults-6mo", name: "Teens & Adults Unlimited", price: "$169", period: "/ month", term: "6-month commitment", features: ["Unlimited teen & adult classes", "Gi, No-Gi & self-defense", "Lowest monthly rate for adults"], url: "https://www.alamedabjj.com/pricing-plans/plan-customization?planId=78797a58-4d61-4036-8338-6b0dac25f144&checkoutFlowId=af70be88-0cb2-4f00-8305-05d79d5292b2&pricingVariantId=8309043b-1ad3-4fbc-ab14-c6cdf1dbbaef" },
  { id: "adults-12mo", name: "Teens & Adults Unlimited", price: "$169", period: "/ month", term: "12-month commitment", features: ["Unlimited teen & adult classes", "Gi, No-Gi & self-defense", "Lock in your rate for a full year"], url: "https://www.alamedabjj.com/pricing-plans/plan-customization?planId=78797a58-4d61-4036-8338-6b0dac25f144&checkoutFlowId=d17a13dc-788c-4aae-bc2b-57c3dac9e96c&pricingVariantId=8309043b-1ad3-4fbc-ab14-c6cdf1dbbaef" },
];

export const BLACK_BELT_PATH = {
  id: "black-belt-path",
  name: "Flexible Black Belt Path",
  price: "$249",
  period: "/ month",
  term: "Month-to-month",
  features: ["Unlimited training", "No annual contract", "30 days' written cancellation notice"],
};

export const FAMILY_PLAN = {
  id: "family",
  name: "Family Membership",
  price: "$350",
  period: "/ month",
  term: "For three family members",
  features: ["Unlimited eligible training", "Covers three family members", "Kids, teens & adults train together"],
  url: "https://www.alamedabjj.com/checkout?checkoutId=4f13862c-dcbe-43a3-949c-c370e5caa869&disableContinueShopping=true",
};

export const PRIVATE_LESSONS = {
  single: { name: "Single Private Lesson", price: "$165" },
  pack: { name: "Four-Lesson Package", price: "$500" },
  promo: { name: "Promotional Single Lesson", price: "$99", active: false },
  booking: "private-lesson-1",
};

// Active, confirmed events & services only. Expired promotions are archived (not shown).
export const SPECIALS = [
  { id: "halloween", name: "Big Halloween Party", price: "$40", unit: "per kid", note: "Friday, October 30th · 5:00 – 8:00 PM. Pizza party! Every kid can bring a buddy free of charge.", url: "https://www.alamedabjj.com/checkout?checkoutId=df02658a-7006-44a6-bc6e-810ea6beaddd&disableContinueShopping=true", featured: true },
  { id: "parentsnight", name: "Parents Night Out", price: "$40", unit: "per child", note: "Drop the kids for a fun night of games, jiu-jitsu and pizza while you enjoy a night out." },
  { id: "graduation", name: "Graduation & Belt Testing", price: "$40", unit: "", note: "Belt/stripe testing and graduation ceremony." },
  { id: "birthday", name: "Kids Birthday Party", price: "Custom", unit: "quote", note: "Celebrate on the mats! Jiu-jitsu games, a mini self-defense lesson and party time at the academy. Tell us the date, your child's age and guest count and we'll send a quote.", request: "/contact?topic=birthday" },
];

export const SOCIAL = [
  { id: "instagram", name: "Instagram", url: "https://www.instagram.com/alameda_brazilian_jiujitsu/" },
  { id: "facebook", name: "Facebook", url: "https://www.facebook.com/profile.php?id=100067800385040" },
  { id: "tiktok", name: "TikTok", url: "https://www.tiktok.com/@alamedabjj" },
];


export const INSTRUCTOR = {
  name: "Professor Sergio Silva",
  title: "5th Degree BJJ Black Belt \u2022 Judo Black Belt \u2022 World Champion",
  image: IMAGES.instructor,
  bio: [
    "Professor Sergio Silva is the founder and head instructor of Team Silva Brazilian Jiu-Jitsu & Self-Defense in Alameda. With 37+ years of martial arts experience, he began Judo at age 2 before dedicating his life to Brazilian Jiu-Jitsu, Submission Wrestling and Mixed Martial Arts. He is a 5th degree BJJ black belt, a black belt in Judo, and a Submission Wrestling World Champion.",
    "Before martial arts, Professor Sergio played semi-professional soccer in Brazil, earning scholarships to private high school and college. He moved to the United States in 1999 to grow Brazilian Jiu-Jitsu and share the life-changing benefits of martial arts. A father of two raised in Alameda, he now teaches kids, teens and adults with a focus on confidence, discipline, respect, anti-bullying and real-world self-defense.",
  ],
  mma: [
    "Professor Silva has coached MMA for professional athletes since 1997, working alongside and training with pro fighters and UFC champions including BJ Penn, Maur\u00edcio \u201cShogun\u201d Rua, Murilo \u201cNinja\u201d Rua, Wanderlei Silva and Ralph Gracie, among many others.",
    "He trained with the Gracie Academy from 1997 to 2003. In 2000\u20132001 he received his brown belt from Professor Ralph Gracie and was sent to Seattle to open a Gracie Academy.",
  ],
  tactical: [
    "Professor Silva has trained police and military personnel since 1997. In Brazil, he was the lead instructor for the elite police special forces unit known as TIGRE in the south of the country, and delivered workshops and seminars for the Brazilian Army in 1997, 1998 and 1999.",
    "In 1998 he also worked as a bodyguard for several celebrities in Brazil and provided special security services for major events in Curitiba. In the United States he has trained SWAT and FBI agents, worked in executive protection, and served as the lead instructor for a defensive tactics team from 2020 to 2024.",
  ],
  tacticalHighlights: [
    "Lead Instructor \u2013 TIGRE Police Special Forces (Brazil)",
    "Brazilian Army Seminars \u2013 1997, 1998, 1999",
    "Trained SWAT & FBI Agents (USA)",
    "Executive Protection & Defensive Tactics Lead (2020\u20132024)",
  ],
  achievements: [
    "Submission Wrestling World Champion",
    "5th Degree BJJ Black Belt & Judo Black Belt",
    "4x US Open Champion \u2013 Black Belt Division (+1 at Purple Belt)",
    "3x American Cup Champion",
    "Grapplers Quest No-Gi National Champion \u2013 Las Vegas",
    "3x Fight to Win Pro Champion \u2013 2017, 2018, 2019",
  ],
};

export const LINEAGE = [
  { years: "1991", school: "Carlson Gracie Academy \u2013 Prof. Alexandre Pen\u00e3o" },
  { years: "1992\u20131997", school: "AABB \u2013 Prof. Evanri Gurgel" },
  { years: "1997\u20131999", school: "Gracie Barra \u2013 Prof. Gustavo Muggiati" },
  { years: "1999\u20132003", school: "Ralph Gracie \u2013 Prof. Ralph Gracie" },
  { years: "2006\u20132008", school: "Relson Gracie \u2013 Prof. Relson Gracie" },
  { years: "2008\u20132012", school: "CheckMat \u2013 Prof. Leonardo Vieira" },
];

export const GOOGLE_RATING = { stars: 5, count: "40+" };

export const TESTIMONIALS = [
  {
    name: "Winnie Leung-McCrea",
    role: "Google Review",
    quote: "I began my BJJ journey with Sergio, and it has since become a full family sport for my husband, daughter and me. Everyone made me feel truly welcome from day one.",
  },
  {
    name: "Alexandra Kovacs",
    role: "Google Review · Local Guide",
    quote: "Sergio Silva is truly one of the best coaches I've ever trained with. His attention to detail, deep knowledge and ability to explain techniques clearly make every session incredibly effective.",
  },
  {
    name: "TamJohnny2012 Chen",
    role: "Google Review · Parent",
    quote: "Sergio goes 110% for the kids! My two boys have grown tremendously \u2014 not only in BJJ, but in becoming better people. They come home more emotionally regulated and confident.",
  },
  {
    name: "Tam Dang",
    role: "Google Review · Parent",
    quote: "We've been with Sergio for more than 3 years. The standout difference is he's not just giving jiu-jitsu classes \u2014 he's a great human being and role model for the kids.",
  },
  {
    name: "Julio Linhares",
    role: "Google Review",
    quote: "I love this place! Such a great teacher \u2014 skilled, patient and full of positive energy. He makes every class fun while still pushing us to improve. You always leave with a smile!",
  },
  {
    name: "Bry Dillon",
    role: "Google Review",
    quote: "Been training with Sergio for 12 years. A top-level instructor who has produced many black belts. This is more than an academy \u2014 it's a family!",
  },
  {
    name: "Christopher McCarver",
    role: "Google Review",
    quote: "I've been training with Sergio for over 10 years. Awesome kids classes with a friendly atmosphere, an attentive after-school program, and great workouts for all levels. Highly recommend!",
  },
  {
    name: "Luis Soltero",
    role: "Google Review",
    quote: "My three children and I have trained for 4 years now. It's a great community and a fun place to be \u2014 kids classes, toddler classes and more. Sergio is a great teacher and champion!",
  },
  {
    name: "Michael Butterfield",
    role: "Google Review · Parent",
    quote: "Sergio has done a great job teaching my 6-year-old son BJJ \u2014 so good, in fact, that it inspired me to take it up at age 40. Can't say enough good things about Sergio and his staff!",
  },
  {
    name: "Nathan Walrath",
    role: "Google Review · Local Guide",
    quote: "Great place for all levels of BJJ. Nice people, a real family-owned and run business. Kids classes, self-defense, teens classes \u2014 they've got it all!",
  },
  {
    name: "Peter Au",
    role: "Google Review",
    quote: "Sergio is a great instructor for both the kids class and adults! It's a great community and a fun environment.",
  },
  {
    name: "Adam Travis",
    role: "Google Review",
    quote: "I visited three different academies in the area before choosing Team Silva \u2014 for the team atmosphere and the individualized attention from the instructors. The higher belts are welcoming and helpful.",
  },
];

export const AFTER_SCHOOL = {
  hero: IMAGES.teaching,
  intro:
    "Our After-School Martial Arts program picks up your child from elementary schools across Alameda and brings them straight to the dojo \u2014 where they practice Martial Arts, learn essential Life Skills, and build Fitness in a safe, positive environment.",
  pillars: [
    {
      title: "Safe Pickup",
      text: "We pick up kids from all elementary schools in Alameda and transport them safely to the dojo.",
    },
    {
      title: "Martial Arts",
      text: "Age-appropriate Brazilian Jiu-Jitsu builds coordination, discipline and real self-defense.",
    },
    {
      title: "Life Skills",
      text: "Focus, respect, confidence and Verbal Jiu-Jitsu\u2122 to handle conflict the right way.",
    },
    {
      title: "Fitness & Fun",
      text: "Active play and structured training keep kids healthy, happy and off the screens.",
    },
  ],
  schools: [
    "Bay Farm School",
    "Earhart Elementary",
    "Edison Elementary",
    "Franklin Elementary",
    "Lum Elementary",
    "Maya Lin School",
    "Otis Elementary",
    "Paden Elementary",
    "Ruby Bridges Elementary",
  ],
};
